import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Vuex from 'vuex'
import { startSessionWatcher } from './utils/sessionWatcher'

import {
  AlertPlugin, BadgePlugin, CarouselPlugin, LayoutPlugin,
  ModalPlugin, DropdownPlugin, ListGroupPlugin,
  CollapsePlugin, NavPlugin, NavbarPlugin, ButtonPlugin,
  FormPlugin, FormCheckboxPlugin, FormGroupPlugin,
  FormInputPlugin, InputGroupPlugin, FormSelectPlugin,
  FormFilePlugin, FormTextareaPlugin, SpinnerPlugin,
  TablePlugin, TabsPlugin, ImagePlugin, FormRadioPlugin,
  FormDatepickerPlugin, PopoverPlugin, ToastPlugin, IconsPlugin
} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import VueDayjs from 'vue-dayjs-plugin'
import 'dayjs/locale/fr'

import VCalendar from 'v-calendar';

import DateInput from '@/components/DateInput.vue'

// Design system, imported last so it overrides Bootstrap and the third party
// stylesheets. Order matters: tokens, then the base layer, then the
// components, then the navigation, then the smartphone layer.
import '@/assets/design/tokens.css'
import '@/assets/design/base.css'
import '@/assets/design/components.css'
import '@/assets/design/navigation.css'
import '@/assets/mobile.css'

Vue.config.productionTip = false

Vue.use(Vuex)

Vue.use(AlertPlugin)
Vue.use(BadgePlugin)
Vue.use(CarouselPlugin)
Vue.use(LayoutPlugin)
Vue.use(ListGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(DropdownPlugin)
Vue.use(CollapsePlugin)
Vue.use(NavPlugin)
Vue.use(NavbarPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(InputGroupPlugin)
Vue.use(SpinnerPlugin)
Vue.use(FormFilePlugin)
Vue.use(FormTextareaPlugin)
Vue.use(TablePlugin)
Vue.use(TabsPlugin)
Vue.use(FormSelectPlugin)
Vue.use(ImagePlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(PopoverPlugin)
Vue.use(ToastPlugin)
Vue.use(IconsPlugin)

Vue.use(VueDayjs)
Vue.use(VCalendar)

Vue.component('custom-loading-component', Loading)
Vue.component('date-input', DateInput)

startSessionWatcher(store, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')